import React from "react";

const STATUS_LABELS = {
  active: "Active",
  checked_in: "Checked in",
  cancelled: "Cancelled",
  void: "Void",
  pending: "Pending",
};

export default function TicketStatusBadge({ status }) {
  const normalized = String(status || "unknown").toLowerCase();
  const label = STATUS_LABELS[normalized] || normalized.replace(/_/g, " ") || "Unknown";

  return (
    <span className={`rrh-status-badge rrh-status-badge--${normalized}`}>
      {label}
    </span>
  );
}
